import Image from 'next/image';

import styles from './divider.module.scss';

export default function Divider() {
  return (
    <div className={styles.divider}>
      <div className={styles.divider_line} />
      <div className={styles.divider_logo}>
        <Image alt="roomster logo" width={45} height={46} src="/images/roomster-logo/logo.svg" />
      </div>
      <div className={styles.divider_line} />
    </div>
  );
}
